module.exports = __webpack_public_path__ + "clip.png?5b18b87582e930ff9a8a3f7101d39f7d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clip.png
// module id = 30
// module chunks = 0